class TemplateEmail {
    static generateThankYouEmail(inscricao) {
        const { nome, local, capaEmail, dataInicio, telefoneContato } = inscricao.rodada;

        let urlUsuario = "https://paeco-linkme.web.app/#/painel-controle?rodada=ZyOo7dcMIBXKuGlQXxyJ";
        // Clique no botão abaixo para visualizar os dados da sua inscrição:
        // </p>
        // <a href="${urlUsuario}" 
        // style="background-color: #4CAF50; color: #fff; padding: 12px 24px; text-decoration: none; border-radius: 5px; font-weight: bold;">
        // Ver minha inscrição
        // </a> 

        const formatPhone = (phone) => {
            if (!phone) return '';
            const phoneStr = phone.toString();
            if (phoneStr.length === 11) {
                return `(${phoneStr.slice(0, 2)}) ${phoneStr.slice(2, 7)}-${phoneStr.slice(7)}`;
            }
            return phoneStr;
        };


        //${imgBase64 ? `<img src="${imgBase64}" alt="Capa do Evento" style="max-width: 100%; height: auto; margin-bottom: 20px;"/>` : ''}


        return `
            <!DOCTYPE html>
                <html lang="pt-BR">
                <head>
                    <meta charset="UTF-8" />
                    <meta name="viewport" content="width=device-width, initial-scale=1.0"/>
                    <title>Confirmação de Inscrição</title>
                </head>
                <body style="margin: 0; padding: 0; font-family: Arial, sans-serif; background-color: #f4f4f4;">
                    <table width="100%" bgcolor="#f4f4f4" cellpadding="0" cellspacing="0" style="padding: 40px 0;">
                    <tr>
                        <td align="center">
                        <table width="600" bgcolor="#ffffff" cellpadding="0" cellspacing="0" style="border-radius: 8px; overflow: hidden; box-shadow: 0 2px 8px rgba(0,0,0,0.1);">
                            <tr>
                            <td align="center" style="padding: 30px;">
                                <h2 style="margin: 0; color: #333;">Obrigado por se inscrever!</h2>
                                <p style="font-size: 16px; color: #555; line-height: 1.5; margin: 20px 0 30px;">
                                Sua inscrição para a <strong>${nome}</strong> foi confirmada com sucesso.<br/>
                                Detalhes do evento:
                                <br/>
                                <strong>Local:</strong> ${local}<br/>
                                <strong>Data:</strong> ${new Date(dataInicio).toLocaleDateString('pt-BR', { day: '2-digit', month: '2-digit', year: 'numeric', hour: '2-digit', minute: '2-digit' })}<br/>
                               
                                <p>
                                    Em caso de dúvidas, entre em contato com ${formatPhone(telefoneContato)}.
                                </p>

                                <p style="font-size: 12px; color: #999; margin-top: 40px;">
                                Se você não se inscreveu neste evento, ignore este e-mail.
                                </p>
                            </td>
                            </tr>
                            <tr>
                            <td bgcolor="#f4f4f4" style="text-align: center; padding: 20px; font-size: 12px; color: #999;">
                                &copy; 2024 Nome do Evento. Todos os direitos reservados.
                            </td>
                            </tr>
                        </table>
                        </td>
                    </tr>
                    </table>
                </body>
                </html>
                `;
        // return `
        //     <html>
        //         <body>
        //             <h1>Obrigado por se inscrever!</h1>
        //             <p>Olá,</p>
        //             <p>Agradecemos por se inscrever na rodada de negócios <strong>${nome}</strong>.</p>
        //             <p>Detalhes do evento:</p>
        //             <ul>
        //                 <li><strong>Data:</strong> ${data}</li>
        //                 <li><strong>Local:</strong> ${local}</li>
        //             </ul>
        //             <p>Estamos ansiosos para sua participação!</p>
        //             <p>Atenciosamente,</p>
        //             <p>Equipe de Organização</p>
        //         </body>
        //     </html>
        // `;
    }
}

export default TemplateEmail;